module.exports = __webpack_public_path__ + "img/box_pro_one_3.0b21d558.jpg";